// @flow

import React, {Component} from 'react';
import {connector} from '../store';
import ClipCarousel from './ClipCarousel.jsx';
import ClipList from './ClipList.jsx';

export class ClipBar extends Component<*, *> {

  constructor(props: *) {
    super(props);
    this.state = {
      mobile: document.documentElement && document.documentElement.clientWidth < 769
    }
  }

  render() {
    if (this.state.mobile) {
      return <ClipList clipAction={this.props.loadPlayerData} />
    } else {
      return <ClipCarousel clipAction={this.props.loadPlayerData} />
    }
  }
}

export default connector(ClipBar);